// Import model
import { FilterPatternTypeOptionRequest } from '../models/FilterPatternTypeOptionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { PatternTypeOptionCondition } from '../models/PatternTypeOptionCondition';
import { PatternTypeOptionFields } from '../models/PatternTypeOptionFields';
import { PatternTypeOptionIndexedFields } from '../models/PatternTypeOptionIndexedFields';

// Import dependency serializers (for complex types)
import { PatternTypeOptionConditionSerializer } from './PatternTypeOptionConditionSerializer';
import { PatternTypeOptionFieldsSerializer } from './PatternTypeOptionFieldsSerializer';
import { PatternTypeOptionIndexedFieldsSerializer } from './PatternTypeOptionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterPatternTypeOptionRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterPatternTypeOptionRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterPatternTypeOptionRequest instance
   */
  static deserialize(json: string): FilterPatternTypeOptionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterPatternTypeOptionRequest instance
   */
  static fromObject(obj: any): FilterPatternTypeOptionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterPatternTypeOptionRequest');
    }


    const instance: FilterPatternTypeOptionRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as PatternTypeOptionIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as PatternTypeOptionFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        PatternTypeOptionConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterPatternTypeOptionRequest instances
   */
  static deserializeArray(json: string): FilterPatternTypeOptionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterPatternTypeOptionRequest instance to a JSON string
   */
  static serialize(instance: FilterPatternTypeOptionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterPatternTypeOptionRequest instance to a plain object
   */
  static toObject(instance: FilterPatternTypeOptionRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        PatternTypeOptionConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterPatternTypeOptionRequest instances to a JSON string
   */
  static serializeArray(instances: FilterPatternTypeOptionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
